"use client";

import { useTransition } from "react";

import { Button } from "@/components/button/button.component";
import { CloseIcon } from "@/components/icons/close.icon";
import { Text } from "@/components/text/text.component";

import { BasketModel } from "@/lib/basket/basket.model";

import { goToCart } from "@/app/blu/(checkout-flow)/actions";
import { removeCookie } from "@/app/actions";
import { SHOW_SUMMARY_COOKIE } from "@/app/blu/shop/constants";
import { GetCartLineProductsQueryResult } from "@/sanity.types";

import { Toast } from "../toast.container";
import { ToastOrderSummaryLineItems } from "./toastOrderSummaryLineItems.component";

export const ToastOrderSummary = ({
  lineItems,
  products,
  show,
}: ToastOrderSummaryProps) => {
  const [isPending, startTransition] = useTransition();

  const handleGoToCart = () => {
    startTransition(() => {
      void goToCart();
    });
  };

  return (
    <Toast show={show} className="justify-self-end">
      <div className="border-greyscale-background shadow-soft-blue absolute right-6 flex max-h-[calc(100dvh-300px)] flex-col overflow-hidden rounded-2xl border bg-white py-6">
        <header className="flex px-6">
          <Text variant="h6" className="flex flex-1">
            Added to cart
          </Text>
          <div className="flex items-center justify-center">
            <button
              type="button"
              className="cursor-pointer"
              onClick={() => void removeCookie({ id: SHOW_SUMMARY_COOKIE })}>
              <CloseIcon />
            </button>
          </div>
        </header>
        <div className="flex flex-col gap-4 overflow-hidden">
          <section className="flex flex-1 flex-col overflow-y-auto px-6">
            <ToastOrderSummaryLineItems
              products={products}
              lineItems={lineItems}
            />
          </section>
          <footer className="flex justify-end px-6">
            <Button
              onClick={handleGoToCart}
              secondary
              border
              className="px-6"
              loading={isPending}
              disabled={isPending}
              aria-busy={isPending}>
              GO TO CART
            </Button>
          </footer>
        </div>
      </div>
    </Toast>
  );
};

export type ToastOrderSummaryProps = {
  products: GetCartLineProductsQueryResult;
  lineItems: BasketModel["accessories"];
  show?: boolean;
};
